import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, normalizeClass as _normalizeClass, withCtx as _withCtx, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0f049ff3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row lockHeader" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "subheader col-lg-3" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "subheader-title" }, " 経費精算書 ")
], -1))
const _hoisted_3 = {
  class: "subheader-block ml-auto demo col-lg-9",
  style: {"text-align":"right"}
}
const _hoisted_4 = ["disabled"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fal fa-file-excel mr-1" }, null, -1))
const _hoisted_6 = ["disabled"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fal fa-file-invoice-dollar mr-1" }, null, -1))
const _hoisted_8 = ["disabled"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fal fa-file-invoice-dollar mr-1" }, null, -1))
const _hoisted_10 = ["disabled"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fal fa-download mr-1" }, null, -1))
const _hoisted_12 = ["disabled"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fal fa-check mr-1" }, null, -1))
const _hoisted_14 = ["disabled"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fal fa-check mr-1" }, null, -1))
const _hoisted_16 = ["disabled"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fal fa-check mr-1" }, null, -1))
const _hoisted_18 = ["disabled"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fal fa-times mr-1" }, null, -1))
const _hoisted_20 = ["disabled"]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fal fa-reply mr-1" }, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "lockHeaderSpacer" }, null, -1))
const _hoisted_23 = {
  key: 0,
  class: "alert alert-danger"
}
const _hoisted_24 = { class: "d-flex flex-start w-100" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mr-2 hidden-md-down" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "icon-stack icon-stack-lg" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fal fa-info-circle" })
  ])
], -1))
const _hoisted_26 = { class: "d-flex flex-fill" }
const _hoisted_27 = { class: "flex-fill" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "h5" }, "あなたが承認者です", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " この申請書はあなたが承認者です。以下のボタンから承認か、差戻を選択できます。 ", -1))
const _hoisted_30 = { class: "m-0" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fal fa-check mr-1" }, null, -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"width":"20px"} }, " 　", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fal fa-times mr-1" }, null, -1))
const _hoisted_34 = {
  key: 1,
  class: "alert alert-primary"
}
const _hoisted_35 = { class: "d-flex flex-start w-100" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mr-2 hidden-md-down" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "icon-stack icon-stack-lg" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fal fa-info-circle" })
  ])
], -1))
const _hoisted_37 = { class: "d-flex flex-fill" }
const _hoisted_38 = { class: "flex-fill" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "h5" }, "この申請書は承認依頼中です", -1))
const _hoisted_40 = { key: 0 }
const _hoisted_41 = { key: 1 }
const _hoisted_42 = {
  key: 2,
  class: "m-0"
}
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fal fa-times mr-1" }, null, -1))
const _hoisted_44 = {
  key: 2,
  class: "alert alert-danger"
}
const _hoisted_45 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex flex-start w-100\" data-v-0f049ff3><div class=\"mr-2 hidden-md-down\" data-v-0f049ff3><span class=\"icon-stack icon-stack-lg\" data-v-0f049ff3><i class=\"fal fa-info-circle\" data-v-0f049ff3></i></span></div><div class=\"d-flex flex-fill\" data-v-0f049ff3><div class=\"flex-fill\" data-v-0f049ff3><span class=\"h5\" data-v-0f049ff3>この申請書は差戻しされました</span><p data-v-0f049ff3> 承認者から差戻しされた場合は、差戻し理由を確認の上、この申請書を修正して、再度承認申請を出してください。 </p></div></div></div>", 1)
const _hoisted_46 = [
  _hoisted_45
]
const _hoisted_47 = {
  key: 3,
  class: "alert alert-primary"
}
const _hoisted_48 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex flex-start w-100\" data-v-0f049ff3><div class=\"mr-2 hidden-md-down\" data-v-0f049ff3><span class=\"icon-stack icon-stack-lg\" data-v-0f049ff3><i class=\"fal fa-info-circle\" data-v-0f049ff3></i></span></div><div class=\"d-flex flex-fill\" data-v-0f049ff3><div class=\"flex-fill\" data-v-0f049ff3><span class=\"h5\" data-v-0f049ff3>この申請書は取り下げられました</span><p data-v-0f049ff3> この申請書は申請者により取り下げられています。管理権限者はこの申請書を削除する事ができます。 </p></div></div></div>", 1)
const _hoisted_49 = [
  _hoisted_48
]
const _hoisted_50 = { class: "row" }
const _hoisted_51 = { class: "col-xl-12" }
const _hoisted_52 = {
  id: "panel-1",
  class: "panel"
}
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "panel-hdr" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "申請時用"),
  /*#__PURE__*/_createElementVNode("div", { class: "panel-toolbar" }, [
    /*#__PURE__*/_createElementVNode("button", {
      class: "btn btn-panel",
      "data-action": "panel-collapse",
      "data-toggle": "tooltip",
      "data-offset": "0,10",
      "data-original-title": "Collapse"
    }),
    /*#__PURE__*/_createElementVNode("button", {
      class: "btn btn-panel",
      "data-action": "panel-fullscreen",
      "data-toggle": "tooltip",
      "data-offset": "0,10",
      "data-original-title": "Fullscreen"
    })
  ])
], -1))
const _hoisted_54 = { class: "panel-container show" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loader" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-spinner-third fa-spin-4x fs-xxl" })
], -1))
const _hoisted_56 = { class: "panel-content contents" }
const _hoisted_57 = { class: "row" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "申請番号", -1))
const _hoisted_59 = { class: "col-md-5 contCnt" }
const _hoisted_60 = { class: "row" }
const _hoisted_61 = { class: "col-md-5 contCnt" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, null, -1))
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-5 contCnt" }, null, -1))
const _hoisted_64 = { class: "row" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "管理名", -1))
const _hoisted_66 = { class: "col-md-5 contCnt" }
const _hoisted_67 = { class: "row" }
const _hoisted_68 = { class: "col-md-5 contCnt" }
const _hoisted_69 = ["disabled"]
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, null, -1))
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-5 contCnt" }, null, -1))
const _hoisted_72 = { class: "row" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "申請日時", -1))
const _hoisted_74 = { class: "col-md-5 contCnt" }
const _hoisted_75 = { class: "row" }
const _hoisted_76 = { class: "col-md-5 contCnt" }
const _hoisted_77 = ["value"]
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, null, -1))
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-5 contCnt" }, null, -1))
const _hoisted_80 = { class: "row" }
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "申請者", -1))
const _hoisted_82 = { class: "col-md-5 contCnt" }
const _hoisted_83 = { class: "row" }
const _hoisted_84 = { class: "col-md-5 contCnt" }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, null, -1))
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-5 contCnt" }, null, -1))
const _hoisted_87 = {
  class: "row",
  style: {"border-top":"1px solid #e5e5e5","padding-top":"10px","margin-bottom":"0"}
}
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "対象年月", -1))
const _hoisted_89 = { class: "col-md-5 contCnt" }
const _hoisted_90 = { class: "row" }
const _hoisted_91 = { class: "col-md-5 contCnt input-daterange" }
const _hoisted_92 = {
  key: 0,
  class: "error-message4vali"
}
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, null, -1))
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-5 contCnt" }, null, -1))
const _hoisted_95 = { class: "row" }
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "起案日", -1))
const _hoisted_97 = { class: "col-md-5 contCnt" }
const _hoisted_98 = { class: "row" }
const _hoisted_99 = { class: "col-md-5 contCnt" }
const _hoisted_100 = ["disabled"]
const _hoisted_101 = {
  key: 0,
  class: "error-message4vali"
}
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, null, -1))
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-5 contCnt" }, null, -1))
const _hoisted_104 = { class: "row" }
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "仮払金", -1))
const _hoisted_106 = { class: "col-md-5 contCnt" }
const _hoisted_107 = { class: "row" }
const _hoisted_108 = { class: "col-md-5 contCnt" }
const _hoisted_109 = ["disabled"]
const _hoisted_110 = {
  key: 0,
  class: "error-message4vali"
}
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, null, -1))
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-5 contCnt" }, null, -1))
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-lg-6 contCnt" }, [
    /*#__PURE__*/_createElementVNode("table", { class: "tb_list" }, [
      /*#__PURE__*/_createElementVNode("tr", null, [
        /*#__PURE__*/_createElementVNode("td", {
          class: "tb_title",
          colspan: "2",
          rowspan: "8",
          "x:str": ""
        }, " 区分 "),
        /*#__PURE__*/_createElementVNode("td", {
          "x:num": "1",
          class: "tb_num"
        }, "1"),
        /*#__PURE__*/_createElementVNode("td", {
          colspan: "3",
          "x:str": "",
          class: "tb_name"
        }, "旅費交通費"),
        /*#__PURE__*/_createElementVNode("td", {
          colspan: "13",
          "x:str": "",
          class: "tb_det"
        }, " 公共交通機関の利用費・駐車場代・ガソリン代・宿泊費など。 ")
      ]),
      /*#__PURE__*/_createElementVNode("tr", null, [
        /*#__PURE__*/_createElementVNode("td", {
          "x:num": "2",
          class: "tb_num"
        }, "2"),
        /*#__PURE__*/_createElementVNode("td", {
          colspan: "3",
          "x:str": "",
          class: "tb_name"
        }, "交際費"),
        /*#__PURE__*/_createElementVNode("td", {
          colspan: "13",
          "x:str": "",
          class: "tb_det"
        }, " 酒類をともなう飲食代。飲食代（税抜5,000円超）、贈答品など。 ")
      ]),
      /*#__PURE__*/_createElementVNode("tr", null, [
        /*#__PURE__*/_createElementVNode("td", {
          "x:num": "3",
          class: "tb_num"
        }, "3"),
        /*#__PURE__*/_createElementVNode("td", {
          colspan: "3",
          "x:str": "",
          class: "tb_name"
        }, "会議費"),
        /*#__PURE__*/_createElementVNode("td", {
          colspan: "13",
          "x:str": "",
          class: "tb_det"
        }, " 喫茶代。飲食代（税抜5,000円以下） ")
      ]),
      /*#__PURE__*/_createElementVNode("tr", null, [
        /*#__PURE__*/_createElementVNode("td", {
          "x:num": "4",
          class: "tb_num"
        }, "4"),
        /*#__PURE__*/_createElementVNode("td", {
          colspan: "3",
          "x:str": "",
          class: "tb_name"
        }, "通信費"),
        /*#__PURE__*/_createElementVNode("td", {
          colspan: "13",
          "x:str": "",
          class: "tb_det"
        }, " 電話代・通信料・郵便代・切手・葉書代・宅配業者、バイク便など。 ")
      ]),
      /*#__PURE__*/_createElementVNode("tr", null, [
        /*#__PURE__*/_createElementVNode("td", {
          "x:num": "5",
          class: "tb_num"
        }, "5"),
        /*#__PURE__*/_createElementVNode("td", {
          colspan: "3",
          "x:str": "",
          class: "tb_name"
        }, "租税公課"),
        /*#__PURE__*/_createElementVNode("td", {
          colspan: "13",
          "x:str": "",
          class: "tb_det"
        }, "収入印紙代")
      ]),
      /*#__PURE__*/_createElementVNode("tr", null, [
        /*#__PURE__*/_createElementVNode("td", {
          "x:num": "6",
          class: "tb_num"
        }, "6"),
        /*#__PURE__*/_createElementVNode("td", {
          colspan: "3",
          "x:str": "",
          class: "tb_name"
        }, "消耗品費"),
        /*#__PURE__*/_createElementVNode("td", {
          colspan: "13",
          "x:str": "",
          class: "tb_det"
        }, " 備品、事務用品など。 ")
      ]),
      /*#__PURE__*/_createElementVNode("tr", null, [
        /*#__PURE__*/_createElementVNode("td", {
          "x:num": "7",
          class: "tb_num"
        }, "7"),
        /*#__PURE__*/_createElementVNode("td", {
          colspan: "3",
          "x:str": "",
          class: "tb_name"
        }, "原価算入"),
        /*#__PURE__*/_createElementVNode("td", {
          colspan: "13",
          "x:str": "",
          class: "tb_det"
        }, " 売上に関する仕入など。 ")
      ]),
      /*#__PURE__*/_createElementVNode("tr", null, [
        /*#__PURE__*/_createElementVNode("td", {
          "x:num": "8",
          class: "tb_num"
        }, "8"),
        /*#__PURE__*/_createElementVNode("td", {
          colspan: "3",
          "x:str": "",
          class: "tb_name"
        }, "その他"),
        /*#__PURE__*/_createElementVNode("td", {
          colspan: "13",
          "x:str": "",
          class: "tb_det"
        }, " 上記にあてはまらないもの。 ")
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "col-lg-6 contCnt" }, [
    /*#__PURE__*/_createElementVNode("table", { class: "tb_list" }, [
      /*#__PURE__*/_createElementVNode("tr", null, [
        /*#__PURE__*/_createElementVNode("td", {
          class: "tb_title",
          colspan: "2",
          rowspan: "8",
          "x:str": ""
        }, " インボイス "),
        /*#__PURE__*/_createElementVNode("td", {
          colspan: "2",
          "x:str": "",
          class: "tb_name"
        }, "T"),
        /*#__PURE__*/_createElementVNode("td", {
          colspan: "14",
          "x:str": "",
          class: "tb_det"
        }, " 登録番号あり。（法人番号を取得しているからと言って、登録番号申請をしているとは限りません。 個人経営店などは、個人名で番号取得している可能性があり、事後のネット検索は不可能です） ")
      ]),
      /*#__PURE__*/_createElementVNode("tr", null, [
        /*#__PURE__*/_createElementVNode("td", {
          colspan: "2",
          "x:str": "",
          class: "tb_name"
        }, "特例"),
        /*#__PURE__*/_createElementVNode("td", {
          colspan: "14",
          "x:str": "",
          class: "tb_det"
        }, " 3万円未満の少額取引、電車代、出張費など。（ただし、一枚領収書で3万円以上は登録番号が必要） ")
      ]),
      /*#__PURE__*/_createElementVNode("tr", null, [
        /*#__PURE__*/_createElementVNode("td", {
          colspan: "2",
          "x:str": "",
          class: "tb_name"
        }, "なし"),
        /*#__PURE__*/_createElementVNode("td", {
          colspan: "14",
          "x:str": "",
          class: "tb_det"
        }, " 登録番号を未取得もしくは、不明。 ")
      ]),
      /*#__PURE__*/_createElementVNode("tr", null, [
        /*#__PURE__*/_createElementVNode("td", {
          colspan: "2",
          "x:str": "",
          class: "tb_name"
        }, "８％"),
        /*#__PURE__*/_createElementVNode("td", {
          colspan: "14",
          "x:str": "",
          class: "tb_det"
        }, " 軽減税率８％の購入。（持ち帰り軽食、飲料、新聞代など） ")
      ]),
      /*#__PURE__*/_createElementVNode("tr", null, [
        /*#__PURE__*/_createElementVNode("td", {
          colspan: "2",
          "x:str": "",
          class: "tb_name"
        }, "０％"),
        /*#__PURE__*/_createElementVNode("td", {
          colspan: "14",
          "x:str": "",
          class: "tb_det"
        }, " 証紙代、印紙代、保険料。もしくは、参加費、会費で消費税明記がない場合。海外での精算。 ")
      ])
    ])
  ])
], -1))
const _hoisted_114 = /*#__PURE__*/_createStaticVNode("<div class=\"row justify-content-between\" data-v-0f049ff3><div class=\"col-auto contTitle\" style=\"text-align:left;\" data-v-0f049ff3><a href=\"media/data/template_keihi_v2.xlsx\" download class=\"btn_template_keihi\" data-v-0f049ff3><span class=\"fal fa-download mr-1\" data-v-0f049ff3></span>Excel入力用テンプレートをダウンロード </a></div><div class=\"col-auto contTitle\" style=\"text-align:right;\" data-v-0f049ff3> （単位：円／税込） </div></div>", 1)
const _hoisted_115 = { class: "row" }
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "国税庁リンク", -1))
const _hoisted_117 = { class: "col-md-5 contCnt" }
const _hoisted_118 = { class: "row" }
const _hoisted_119 = { class: "col-md-7 contCnt" }
const _hoisted_120 = ["disabled"]
const _hoisted_121 = { class: "col-md-6" }
const _hoisted_122 = { class: "row" }
const _hoisted_123 = { class: "col-md-12 contCnt btn-group btn-group-sm text-right" }
const _hoisted_124 = { class: "row" }
const _hoisted_125 = { class: "col contCnt" }
const _hoisted_126 = {
  class: "demo",
  style: {"overflow":"auto"}
}
const _hoisted_127 = { class: "bg-primary-400" }
const _hoisted_128 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  id: "sort4DateUp",
  class: "fal fa-sort-amount-up dispNone"
}, null, -1))
const _hoisted_129 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  id: "sort4DateDown",
  class: "fal fa-sort-amount-down"
}, null, -1))
const _hoisted_130 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "fixhead headKeihi cwK_2" }, "区分", -1))
const _hoisted_131 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "fixhead headKeihi cwK_3" }, "支払先", -1))
const _hoisted_132 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "fixhead headKeihi cwK_4" }, "目的", -1))
const _hoisted_133 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "fixhead headKeihi cwK_5" }, "人数", -1))
const _hoisted_134 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "fixhead headKeihi cwK_6" }, "金額/税込", -1))
const _hoisted_135 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  id: "sort4InvoiceUp",
  class: "fal fa-sort-amount-up dispNone"
}, null, -1))
const _hoisted_136 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  id: "sort4InvoiceDown",
  class: "fal fa-sort-amount-down"
}, null, -1))
const _hoisted_137 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  colspan: "5",
  class: "bg-primary-400",
  style: {"text-align":"center"}
}, " 合計金額（税込） ", -1))
const _hoisted_138 = { class: "keihiCont" }
const _hoisted_139 = { id: "header4Recept" }
const _hoisted_140 = { style: {"width":"250px","position":"absolute","right":"60px","top":"15px"} }
const _hoisted_141 = ["disabled"]
const _hoisted_142 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fal fa-download mr-1" }, null, -1))
const _hoisted_143 = ["disabled"]
const _hoisted_144 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fal fa-external-link-square mr-1" }, null, -1))
const _hoisted_145 = {
  id: "body4Recept",
  class: "panel-container"
}
const _hoisted_146 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loader" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-spinner-third fa-spin-4x fs-xxl" })
], -1))
const _hoisted_147 = {
  key: 0,
  id: "dzFlame",
  style: {"width":"100%","height":"150px","background-color":"white"}
}
const _hoisted_148 = {
  key: 1,
  class: "alert alert-warning",
  role: "alert"
}
const _hoisted_149 = { class: "col-md-12 contTitle" }
const _hoisted_150 = {
  id: "frame-img",
  style: {"box-shadow":"0 0 0.5cm rgba(0, 0, 0, 0.5)","margin":"0 auto","width":"90%","margin-top":"20px","overflow":"hidden"}
}
const _hoisted_151 = {
  key: 1,
  id: "frame-img4None",
  style: {"display":"flex","justify-content":"center","align-items":"center","max-width":"400px","width":"90%","min-height":"420px","margin":"0 auto"}
}
const _hoisted_152 = {
  key: 0,
  style: {"text-align":"center","color":"#3b31a1"},
  class: "h2"
}
const _hoisted_153 = {
  key: 1,
  style: {"text-align":"center","color":"#3b31a1"},
  class: "h2"
}
const _hoisted_154 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/img/backgrounds/imgloading.svg",
    alt: "",
    style: {"width":"100%"}
  })
], -1))
const _hoisted_155 = {
  id: "footer4Recept",
  class: "modal-footer"
}
const _hoisted_156 = ["disabled"]
const _hoisted_157 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fal fa-reply mr-1" }, null, -1))
const _hoisted_158 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-check-circle text-success mr-2" }, null, -1))
const _hoisted_159 = { class: "text-success fw-500" }
const _hoisted_160 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_161 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-footer" }, [
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_162 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-times-circle text-danger mr-2" }, null, -1))
const _hoisted_163 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_164 = { class: "modal-footer" }
const _hoisted_165 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-times-circle text-danger mr-2" }, null, -1))
const _hoisted_166 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_167 = { class: "modal-footer" }
const _hoisted_168 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-times-circle text-danger mr-2" }, null, -1))
const _hoisted_169 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_170 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vSelect = _resolveComponent("vSelect")!
  const _component_Mt_dtp4month = _resolveComponent("Mt_dtp4month")!
  const _component_Mo_expenses_row = _resolveComponent("Mo_expenses_row")!
  const _component_dropzone = _resolveComponent("dropzone")!
  const _component_Or_pdfviewer = _resolveComponent("Or_pdfviewer")!
  const _component_Mo_modal_right_l = _resolveComponent("Mo_modal_right_l")!
  const _component_Mo_modal_alert = _resolveComponent("Mo_modal_alert")!

  return (_openBlock(), _createElementBlock("main", {
    id: "js-page-content",
    role: "main",
    class: _normalizeClass(["page-content", {
      isEdit: _ctx.isEditMode,
    }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("input", {
          type: "file",
          ref: "fileInput",
          onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleFileChange && _ctx.handleFileChange(...args))),
          style: {"display":"none"}
        }, null, 544),
        (
            !_ctx.isEditMode &&
            (_ctx.delegate.request.c_request_status == null ||
              _ctx.delegate.request.c_request_status == 0 ||
              _ctx.delegate.request.c_request_status == 2)
          )
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "btn btn-success waves-effect waves-themed",
              disabled: _ctx.btnDisable,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openFileSelector()))
            }, [
              _hoisted_5,
              _createTextVNode("インポート ")
            ], 8, _hoisted_4))
          : _createCommentVNode("", true),
        (_ctx.delegate.c_request_expenses_id != null)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (
              _ctx.delegate.docfile != null &&
              _ctx.delegate.docfile.url4Show != null &&
              _ctx.delegate.docfile.url4Show != ''
            )
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn btn-primary waves-effect waves-themed",
                    disabled: _ctx.btnDisable,
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showModal4Receipt()))
                  }, [
                    _hoisted_7,
                    _createTextVNode("領収書 ")
                  ], 8, _hoisted_6))
                : (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    type: "button",
                    class: "btn btn-warning waves-effect waves-themed",
                    disabled: _ctx.btnDisable,
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showModal4Receipt()))
                  }, [
                    _hoisted_9,
                    _createTextVNode("領収書未登録 ")
                  ], 8, _hoisted_8))
            ], 64))
          : _createCommentVNode("", true),
        (
            _ctx.isEditMode ||
            _ctx.delegate.request.c_request_status == 0 ||
            _ctx.delegate.request.c_request_status == 2
          )
          ? (_openBlock(), _createElementBlock("button", {
              key: 2,
              type: "button",
              class: "btn btn-success waves-effect waves-themed",
              disabled: _ctx.btnDisable,
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.dl()))
            }, [
              _hoisted_11,
              _createTextVNode("Excel出力 ")
            ], 8, _hoisted_10))
          : _createCommentVNode("", true),
        (!_ctx.isEditMode && _ctx.delegate.request.c_request_status == null)
          ? (_openBlock(), _createElementBlock("button", {
              key: 3,
              type: "button",
              disabled: _ctx.btnDisable,
              class: "btn btn-info waves-effect waves-themed",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.add()))
            }, [
              _hoisted_13,
              _createTextVNode("追加 ")
            ], 8, _hoisted_12))
          : _createCommentVNode("", true),
        (
            !_ctx.isEditMode && _ctx.delegate.request.c_request_status != null /*&&
            (delegate.request.c_request_status == 0 ||
              delegate.request.c_request_status == 2)*/
          )
          ? (_openBlock(), _createElementBlock("button", {
              key: 4,
              type: "button",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.updNormal(false))),
              disabled: _ctx.btnDisable,
              class: "btn btn-info waves-effect waves-themed"
            }, [
              _hoisted_15,
              _createTextVNode("登録 ")
            ], 8, _hoisted_14))
          : _createCommentVNode("", true),
        (
            (_ctx.isEditMode && _ctx.isMine && _ctx.delegate.request.c_request_status != 4) ||
            (_ctx.isMine && _ctx.delegate.request.c_request_status == 2)
          )
          ? (_openBlock(), _createElementBlock("button", {
              key: 5,
              type: "button",
              disabled: _ctx.btnDisable,
              class: "btn btn-warning waves-effect waves-themed",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.disableConf()))
            }, [
              _hoisted_17,
              _createTextVNode("取下 ")
            ], 8, _hoisted_16))
          : _createCommentVNode("", true),
        (
            (_ctx.isEditMode && _ctx.isAdmin) ||
            (_ctx.isMine && _ctx.delegate.request.c_request_status == 0)
          )
          ? (_openBlock(), _createElementBlock("button", {
              key: 6,
              type: "button",
              disabled: _ctx.btnDisable,
              class: "btn btn-danger waves-effect waves-themed",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.delConf()))
            }, [
              _hoisted_19,
              _createTextVNode("削除 ")
            ], 8, _hoisted_18))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          disabled: _ctx.btnDisable,
          type: "button",
          class: "btn btn-secondary waves-effect waves-themed",
          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$router.push('/shinseisyolist')))
        }, [
          _hoisted_21,
          _createTextVNode("戻る ")
        ], 8, _hoisted_20)
      ])
    ]),
    _hoisted_22,
    (_ctx.fmShowConf)
      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _hoisted_25,
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _hoisted_28,
                _hoisted_29,
                _createElementVNode("p", _hoisted_30, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-info waves-effect waves-themed",
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.upd4Approval(true)))
                  }, [
                    _hoisted_31,
                    _createTextVNode("承認 ")
                  ]),
                  _hoisted_32,
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-danger waves-effect waves-themed",
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.upd4Approval(false)))
                  }, [
                    _hoisted_33,
                    _createTextVNode("差戻 ")
                  ])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.fmShowConfEx)
      ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, [
            _hoisted_36,
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                _hoisted_39,
                (_ctx.fmShowConfEx4Other)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_40, " この申請書は承認依頼中です。お急ぎの場合は、承認者にご連絡ください。 "))
                  : _createCommentVNode("", true),
                (_ctx.fmShowConfEx4Mine)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_41, " この申請書は承認依頼中です。再編集する場合は、以下のボタンからご自身で差戻してください。 "))
                  : _createCommentVNode("", true),
                (_ctx.fmShowConfEx4Mine)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_42, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-danger waves-effect waves-themed",
                        onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.upd4Approval(false)))
                      }, [
                        _hoisted_43,
                        _createTextVNode("差戻 ")
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.fmShowSasimodosi)
      ? (_openBlock(), _createElementBlock("div", _hoisted_44, _hoisted_46))
      : _createCommentVNode("", true),
    (_ctx.fmShowTorisage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_47, _hoisted_49))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_50, [
      _createElementVNode("div", _hoisted_51, [
        _createElementVNode("div", _hoisted_52, [
          _hoisted_53,
          _createElementVNode("div", _hoisted_54, [
            _hoisted_55,
            _createElementVNode("div", _hoisted_56, [
              _createElementVNode("div", _hoisted_57, [
                _hoisted_58,
                _createElementVNode("div", _hoisted_59, [
                  _createElementVNode("div", _hoisted_60, [
                    _createElementVNode("div", _hoisted_61, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        name: "txtKouzaCd",
                        class: "form-control form-control-sm",
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.delegate.request.c_request_id) = $event)),
                        disabled: ""
                      }, null, 512), [
                        [_vModelText, _ctx.delegate.request.c_request_id]
                      ])
                    ]),
                    _hoisted_62,
                    _hoisted_63
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_64, [
                _hoisted_65,
                _createElementVNode("div", _hoisted_66, [
                  _createElementVNode("div", _hoisted_67, [
                    _createElementVNode("div", _hoisted_68, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control form-control-sm",
                        placeholder: "xxxx案件でyyyy作業の為",
                        disabled: _ctx.isEditMode,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.delegate.request.c_request_name) = $event))
                      }, null, 8, _hoisted_69), [
                        [_vModelText, _ctx.delegate.request.c_request_name]
                      ])
                    ]),
                    _hoisted_70,
                    _hoisted_71
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_72, [
                _hoisted_73,
                _createElementVNode("div", _hoisted_74, [
                  _createElementVNode("div", _hoisted_75, [
                    _createElementVNode("div", _hoisted_76, [
                      _createElementVNode("input", {
                        type: "text",
                        name: "txtStartDate",
                        class: "form-control form-control-sm",
                        value: 
                          _ctx.convDateTime(_ctx.delegate.request.c_request_datetime)
                        ,
                        disabled: ""
                      }, null, 8, _hoisted_77)
                    ]),
                    _hoisted_78,
                    _hoisted_79
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_80, [
                _hoisted_81,
                _createElementVNode("div", _hoisted_82, [
                  _createElementVNode("div", _hoisted_83, [
                    _createElementVNode("div", _hoisted_84, [
                      (_ctx.isAdmin && !_ctx.isEditMode)
                        ? (_openBlock(), _createBlock(_component_vSelect, {
                            key: 0,
                            options: _ctx.getOpStaffs(),
                            label: "c_staff_name",
                            modelValue: _ctx.delegate.request.c_staff_id,
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.delegate.request.c_staff_id) = $event)),
                            reduce: (label) => label.c_staff_id
                          }, null, 8, ["options", "modelValue", "reduce"]))
                        : _withDirectives((_openBlock(), _createElementBlock("input", {
                            key: 1,
                            type: "text",
                            name: "txtKouzaCd",
                            class: "form-control form-control-sm",
                            disabled: "",
                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.domApplicantName) = $event))
                          }, null, 512)), [
                            [_vModelText, _ctx.domApplicantName]
                          ])
                    ]),
                    _hoisted_85,
                    _hoisted_86
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_87, [
                _hoisted_88,
                _createElementVNode("div", _hoisted_89, [
                  _createElementVNode("div", _hoisted_90, [
                    _createElementVNode("div", _hoisted_91, [
                      _createVNode(_component_Mt_dtp4month, {
                        disabled: _ctx.isEditMode,
                        contdate: _ctx.domTargetDate,
                        "onUpdate:contdate": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.domTargetDate) = $event))
                      }, null, 8, ["disabled", "contdate"]),
                      (_ctx.errors?.path === 'targetDate')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_92, _toDisplayString(_ctx.errors.message), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _hoisted_93,
                  _hoisted_94
                ])
              ]),
              _createElementVNode("div", _hoisted_95, [
                _hoisted_96,
                _createElementVNode("div", _hoisted_97, [
                  _createElementVNode("div", _hoisted_98, [
                    _createElementVNode("div", _hoisted_99, [
                      _withDirectives(_createElementVNode("input", {
                        type: "date",
                        name: "txtStartDate",
                        class: "form-control form-control-sm",
                        maxlength: "10",
                        disabled: _ctx.isEditMode,
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.domStartDate) = $event))
                      }, null, 8, _hoisted_100), [
                        [_vModelText, _ctx.domStartDate]
                      ]),
                      (_ctx.errors?.path === 'startDate')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_101, _toDisplayString(_ctx.errors.message), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _hoisted_102,
                    _hoisted_103
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_104, [
                _hoisted_105,
                _createElementVNode("div", _hoisted_106, [
                  _createElementVNode("div", _hoisted_107, [
                    _createElementVNode("div", _hoisted_108, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control form-control-sm",
                        maxlength: "50",
                        onFocus: _cache[19] || (_cache[19] = ($event: any) => (_ctx.kanmaDel($event))),
                        onBlur: _cache[20] || (_cache[20] = ($event: any) => (_ctx.kanmaIns($event))),
                        style: {"text-align":"right"},
                        disabled: _ctx.isEditMode,
                        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.domTmppay_price) = $event))
                      }, null, 40, _hoisted_109), [
                        [_vModelText, _ctx.domTmppay_price]
                      ]),
                      (_ctx.errors?.path === 'tmppayPrice')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_110, _toDisplayString(_ctx.errors.message), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _hoisted_111,
                    _hoisted_112
                  ])
                ])
              ]),
              _hoisted_113,
              _hoisted_114,
              _createElementVNode("div", _hoisted_115, [
                _hoisted_116,
                _createElementVNode("div", _hoisted_117, [
                  _createElementVNode("div", _hoisted_118, [
                    _createElementVNode("div", _hoisted_119, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control form-control-sm",
                        placeholder: "13桁半角数字で登録番号を入力してください",
                        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.domRegistNum) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.domRegistNum]
                      ])
                    ]),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-primary waves-effect waves-themed",
                      disabled: _ctx.btnDisable,
                      onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.goToTaxSite()))
                    }, " 検索 ", 8, _hoisted_120)
                  ])
                ]),
                _createElementVNode("div", _hoisted_121, [
                  _createElementVNode("div", _hoisted_122, [
                    _createElementVNode("div", _hoisted_123, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-primary waves-effect waves-themed",
                        onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.addRow()))
                      }, " 行追加 "),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-primary waves-effect waves-themed",
                        onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.delRow()))
                      }, " 行削除 "),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-primary waves-effect waves-themed",
                        onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.sortRowUp()))
                      }, " ▲ "),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-primary waves-effect waves-themed",
                        onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.sortRowDown()))
                      }, " ▼ ")
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_124, [
                _createElementVNode("div", _hoisted_125, [
                  _createElementVNode("div", _hoisted_126, [
                    _createElementVNode("table", {
                      class: _normalizeClass(["table table-sm table-bordered m-0 tableKeihi", {
                        isEdit: _ctx.isEditMode,
                      }]),
                      style: {"min-width":"1200px"}
                    }, [
                      _createElementVNode("thead", _hoisted_127, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", {
                            id: "sort4DateHead",
                            class: "fixhead headKeihi cwK_1",
                            onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.sortRow4Date()))
                          }, [
                            _createTextVNode(" 使用月日 "),
                            _hoisted_128,
                            _hoisted_129
                          ]),
                          _hoisted_130,
                          _hoisted_131,
                          _hoisted_132,
                          _hoisted_133,
                          _hoisted_134,
                          _createElementVNode("th", {
                            id: "sort4InvoiceHead",
                            class: "fixhead headKeihi cwK_7",
                            onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.sortRow4invoice()))
                          }, [
                            _createTextVNode(" インボイス "),
                            _hoisted_135,
                            _hoisted_136
                          ])
                        ])
                      ]),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.expensesList, (item) => {
                          return (_openBlock(), _createBlock(_component_Mo_expenses_row, {
                            key: item.c_expenses_rownum!,
                            item: item,
                            isDisable: _ctx.isDisableExpensesList,
                            class: "tb_input",
                            onSelected: _cache[30] || (_cache[30] = ($event: any) => (_ctx.selectRow($event))),
                            onReCalc: _cache[31] || (_cache[31] = ($event: any) => (_ctx.sumCalc()))
                          }, null, 8, ["item", "isDisable"]))
                        }), 128))
                      ]),
                      _createElementVNode("tfoot", null, [
                        _createElementVNode("tr", null, [
                          _hoisted_137,
                          _createElementVNode("td", _hoisted_138, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              maxlength: "50",
                              style: {"text-align":"right"},
                              "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.domSumPrice) = $event)),
                              readonly: ""
                            }, null, 512), [
                              [_vModelText, _ctx.domSumPrice]
                            ])
                          ])
                        ])
                      ])
                    ], 2)
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_Mo_modal_right_l, { ref: "Mo_modal_receipt" }, {
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_139, [
          _createTextVNode(" 領収書 "),
          _createElementVNode("div", _hoisted_140, [
            _createElementVNode("button", {
              type: "button",
              id: "btnOpenRecept",
              class: "btn-sm btn-primary waves-effect waves-themed",
              disabled: 
                _ctx.btnDisable ||
                _ctx.delegate.docfile == null ||
                _ctx.delegate.docfile.url4Show == null ||
                _ctx.delegate.docfile.url4Show == ''
              ,
              onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.openRecept()))
            }, [
              _hoisted_142,
              _createTextVNode("ダウンロード ")
            ], 8, _hoisted_141),
            _createElementVNode("button", {
              type: "button",
              id: "btnOpenRecept",
              class: "btn-sm btn-primary waves-effect waves-themed",
              style: {"margin-left":"10px"},
              disabled: 
                _ctx.btnDisable ||
                _ctx.delegate.docfile == null ||
                _ctx.delegate.request.c_request_status != 3
              ,
              onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.goTo('/docedit?id=' + _ctx.delegate.docfile.c_doc_id, $event)))
            }, [
              _hoisted_144,
              _createTextVNode("文書詳細 ")
            ], 8, _hoisted_143)
          ])
        ])
      ]),
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_145, [
          _hoisted_146,
          (_ctx.isMine || _ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_147, [
                _createVNode(_component_dropzone, {
                  fileInfo: _ctx.fileInfo,
                  updateFileInfo: _ctx.updateFileInfo,
                  isMinMode: true
                }, null, 8, ["fileInfo", "updateFileInfo"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_148, " 領収書のアップロードは、自身の経費精算書でのみ可能です。 ")),
          _createElementVNode("div", _hoisted_149, [
            _createElementVNode("div", _hoisted_150, [
              (
                  _ctx.delegate.docfile != null &&
                  _ctx.delegate.docfile.url4Show != null &&
                  _ctx.delegate.docfile.url4Show != '' &&
                  _ctx.showReceptImg
                )
                ? (_openBlock(), _createBlock(_component_Or_pdfviewer, {
                    key: 0,
                    item: _ctx.delegate.docfile
                  }, null, 8, ["item"]))
                : (_openBlock(), _createElementBlock("div", _hoisted_151, [
                    _createElementVNode("div", null, [
                      (
                        _ctx.delegate.docfile != null &&
                        _ctx.delegate.docfile.url4Show != null &&
                        _ctx.delegate.docfile.url4Show != ''
                      )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_152, " 画像読み込み中・・・ "))
                        : (_openBlock(), _createElementBlock("div", _hoisted_153, " 領収書が登録されていません ")),
                      _hoisted_154
                    ])
                  ]))
            ])
          ])
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_155, [
          _createElementVNode("button", {
            disabled: _ctx.btnDisable,
            type: "button",
            class: "btn btn-secondary waves-effect waves-themed",
            onClick: _cache[35] || (_cache[35] = ($event: any) => (_ctx.closeModal4Receipt()))
          }, [
            _hoisted_157,
            _createTextVNode("閉じる ")
          ], 8, _hoisted_156)
        ])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_Mo_modal_alert, {
      ref: "Mo_modal_success",
      onModalclosed: _cache[36] || (_cache[36] = ($event: any) => (_ctx.get()))
    }, {
      title: _withCtx(() => [
        _hoisted_158,
        _createElementVNode("span", _hoisted_159, _toDisplayString(_ctx.message4ModalSuccess), 1)
      ]),
      body: _withCtx(() => [
        _hoisted_160
      ]),
      footer: _withCtx(() => [
        _hoisted_161
      ]),
      _: 1
    }, 512),
    _createVNode(_component_Mo_modal_alert, { ref: "Mo_modal_deleteConf" }, {
      title: _withCtx(() => [
        _hoisted_162,
        _createTextVNode(_toDisplayString(_ctx.message4ModalDelConf), 1)
      ]),
      body: _withCtx(() => [
        _hoisted_163
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_164, [
          _createElementVNode("button", {
            onClick: _cache[37] || (_cache[37] = ($event: any) => (_ctx.del())),
            type: "button",
            class: "btn btn-danger shadow-0 bootbox-accept"
          }, " はい"),
          _createElementVNode("button", {
            onClick: _cache[38] || (_cache[38] = ($event: any) => (_ctx.closeModal4deleteConf())),
            type: "button",
            class: "btn btn-default bootbox-cancel"
          }, " いいえ ")
        ])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_Mo_modal_alert, { ref: "Mo_modal_disableConf" }, {
      title: _withCtx(() => [
        _hoisted_165,
        _createTextVNode(_toDisplayString(_ctx.message4ModalDisableConf), 1)
      ]),
      body: _withCtx(() => [
        _hoisted_166
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_167, [
          _createElementVNode("button", {
            onClick: _cache[39] || (_cache[39] = ($event: any) => (_ctx.disab())),
            type: "button",
            class: "btn btn-danger shadow-0 bootbox-accept"
          }, " はい"),
          _createElementVNode("button", {
            onClick: _cache[40] || (_cache[40] = ($event: any) => (_ctx.closeModal4disableConf())),
            type: "button",
            class: "btn btn-default bootbox-cancel"
          }, " いいえ ")
        ])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_Mo_modal_alert, { ref: "Mo_modal_errorConf" }, {
      title: _withCtx(() => [
        _hoisted_168,
        _createTextVNode(_toDisplayString(_ctx.message4ModalErrorConf), 1)
      ]),
      body: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.message4ModalErrorConfBody), 1),
        _hoisted_169
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_170, [
          _createElementVNode("button", {
            onClick: _cache[41] || (_cache[41] = ($event: any) => (_ctx.closeModal4ErrorConf())),
            type: "button",
            class: "btn btn-default bootbox-cancel"
          }, " 確認 ")
        ])
      ]),
      _: 1
    }, 512)
  ], 2))
}